import React from "react";

function Description() {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>
        iLoveScan: AI PDF Editor Scan - Your Ultimate Document & Image Tool
      </h1>
      <p>
        iLoveScan: AI PDF Editor Scan is the all-in-one solution for scanning,
        editing, and converting documents and images effortlessly. Whether you
        need to extract text with OCR, edit and enhance images, sign PDFs, or
        convert files, iLoveScan: AI PDF Editor Scan has you covered.
      </p>
      <ul>
        <li>
          <strong>Scan & Extract:</strong> OCR, QR, Text, ID, PDF
        </li>
        <li>
          <strong>Edit & Enhance:</strong> Crop, Resize, Rotate, Remove
          Background, Upscale
        </li>
        <li>
          <strong>Sign & Secure:</strong> Sign PDF, Watermark, Sign Image
        </li>
        <li>
          <strong>Compress & Convert:</strong> Images, Videos, Audio, PDF, Zip
        </li>
        <li>
          <strong>Voice & Text Tools:</strong> Voice to Text, Text to Speech
        </li>
        <li>
          <strong>Smart PDF Tools:</strong> PDF to Image, Image to PDF, URL to
          PDF
        </li>
      </ul>
      <p>
        Simplify your workflow and enhance productivity with AI-powered document
        and image processing. Download iLoveScan: AI PDF Editor Scan AI today!
      </p>
    </div>
  );
}

export default Description;
